module.exports = __webpack_public_path__ + "static/img/cjx03.c0145a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx03.png
// module id = 161
// module chunks = 0